import type { ResultadoCotizacion } from '../api'
import { num, pct, usdExacto } from '../formato'
import { ProyeccionConsumo } from './ProyeccionConsumo'

/**
 * De donde salio el consumo de ESTA cotizacion y cuanto le cuesta al cliente esperar.
 * Todo viene del resultado (motor); aqui solo se muestra. El PDF lleva la misma seccion.
 */
export function ConsumoYEspera({ resultado }: { resultado: ResultadoCotizacion }) {
  const consumo = resultado.consumo_usado
  const espera = resultado.costo_esperar
  if (!consumo && !espera) return null

  return (
    <>
      {consumo && (
        <div className="tarjeta">
          <h2>
            Consumo usado{' '}
            <span className={`insignia ${consumo.fuente === 'proyeccion' ? 'insignia-cliente' : 'insignia-pendiente'}`}>
              {consumo.fuente === 'proyeccion' ? 'proyectado del historial' : 'escrito a mano'}
            </span>
          </h2>
          <p>
            Se cotizó con <strong>{num(consumo.kwh_mes)} kWh/mes</strong>
            {consumo.demanda_kw !== null && (
              <>
                {' '}
                y <strong>{num(consumo.demanda_kw)} kW</strong> de demanda
              </>
            )}
            {consumo.fuente === 'proyeccion' ? ': el promedio de los 12 meses proyectados.' : '.'}
          </p>
          {consumo.proyeccion && (
            <>
              <ProyeccionConsumo proyeccion={consumo.proyeccion.kwh} historial={consumo.historial?.kwh} unidad="kWh" />
              {consumo.proyeccion.demanda_kw && (
                <ProyeccionConsumo proyeccion={consumo.proyeccion.demanda_kw} historial={consumo.historial?.demanda_kw ?? []} unidad="kW" />
              )}
            </>
          )}
        </div>
      )}

      {espera && (
        <div className="tarjeta">
          <h2>Costo de esperar</h2>
          {'error' in espera ? (
            <p className="suave">{espera.error}</p>
          ) : (
            <>
              <p>
                Ahorro neto mensual: <strong>{usdExacto(espera.ahorro_mensual)}</strong>{' '}
                <span className="suave">(flujo neto del año 1 —ahorro menos mantenimiento—, {usdExacto(espera.flujo_neto_primer_anio)}, entre 12)</span>
              </p>
              <div className="tabla-envoltura">
                <table className="tabla compacta">
                  <thead>
                    <tr>
                      <th>Si instala dentro de</th>
                      <th className="num">Ahorro que deja de tener</th>
                      <th className="num">Subida del precio del sistema</th>
                      <th className="num">Costo de esperar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {espera.filas.map((f) => (
                      <tr key={f.meses} className="sin-clic">
                        <td>{f.meses} meses</td>
                        <td className="num">{usdExacto(f.ahorro_perdido)}</td>
                        <td className="num">{usdExacto(f.sobrecosto_precio)}</td>
                        <td className="num fuerte">{usdExacto(f.costo_total)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="suave pequeno-texto">
                Supuestos: subida anual de la tarifa {pct(espera.subida_anual_tarifa)}; subida anual del precio del sistema{' '}
                {pct(espera.subida_anual_precio)} sobre {usdExacto(espera.total_sistema)}. Con las dos en 0 %, esperar n meses cuesta
                exactamente n veces el ahorro mensual.
              </p>
            </>
          )}
        </div>
      )}
    </>
  )
}
